import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import StandardProposalDetailContMain from "presentation/view/container/StandardProposal/StandardProposalDetailContMain";

CommonEntrypoint(<StandardProposalDetailContMain/>)